import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "module/main/util";
export var ProgressBar = function (_a) {
    var value = _a.value, max = _a.max, className = _a.className;
    var percent = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
    return (_jsx("div", { className: cx("h-2 w-full overflow-hidden rounded-full bg-[#dbe7f5]", className), children: _jsx("div", { className: "h-full rounded-full bg-primary", style: { width: "".concat(percent, "%") } }) }));
};
export default ProgressBar;
